<template>
  <div class="alumni-spotlights">
    <div class="container" v-show="title || action">
      <div
        class="alumni-spotlights__header"
        ref="paddingOffset"
        :class="{
          'alumni-spotlights__header--action': action !== null,
        }"
      >
        <h2 v-if="title" class="">{{ title }}</h2>
        <div v-if="action" class="alumni-spotlights__action">
          <a class="button" :href="action.Url" :target="action.Target">{{ action.Name }}</a>
        </div>
      </div>
    </div>

    <div class="swiper__container">
      <swiper
        :id="idAttribute"
        :modules="modules"
        :space-between="gutter"
        :navigation="navigation"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :slidesOffsetAfter="paddingRight"
        :slidesOffsetBefore="paddingLeft"
        :scrollbar="scrollbar"
        :allowTouchMove="spotlights.length > 1 ? true : false"
        :draggable="spotlights.length > 1 ? true : false"
        :mousewheel="spotlights.length > 1 ? mousewheel : false"
        :resizeObserver="true"
        :updateOnWindowResize="true"
        :zoom="false"
        :snapIndex="1"
        :breakpoints="breakpoints"
        :snapOnRelease="false"
      >
        <swiper-slide v-for="(spotlight, index) in spotlights" :key="index" class="alumni-spotlights__card">
          <div class="alumni-spotlights__card-header">
            <div class="alumni-spotlights__card-image" :style="`background-image: url('${spotlight.image}');`"></div>
            <div class="alumni-spotlights__card-title">
              <div v-if="spotlight.title">{{ spotlight.title }}</div>
              <div v-if="spotlight.subtitle">{{ spotlight.subtitle }}</div>
            </div>
          </div>
          <div class="alumni-spotlights__card-content" v-if="spotlight.description">
            <div v-html="spotlight.description"></div>
          </div>
          <div class="alumni-spotlights__card-action">
            <a v-if="spotlight.action" class="button" :href="spotlight.action.Url" :target="spotlight.action.Target">{{ spotlight.action.Name }}</a>
          </div>
        </swiper-slide>

        <div id="alumni-spotlights" class="card-carousel__legend">
          <div class="card-carousel__legend-bar"></div>
        </div>
      </swiper>
      <button class="alumni-spotlights__swiper-prev swiper__button swiper__button--prev" type="button"><span>Prev</span></button>
      <button class="alumni-spotlights__swiper-next swiper__button swiper__button--next" type="button"><span>Next</span></button>
    </div>

    <div v-if="action" class="alumni-spotlights__action alumni-spotlights__action--mobile">
      <a class="button" :href="action.Url" :target="action.Target">{{ action.Name }}</a>
    </div>
  </div>
</template>

<script>
import { Mousewheel, Navigation, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/bundle";

export default {
  props: ["idAttribute", "action", "title", "spotlights"],
  data() {
    return {
      gutter: 16,
      paddingLeft: 0,
      paddingRight: 0,
    };
  },
  mounted() {
    let self = this;
    self.setSidePadding();
    window.addEventListener("resize", function () {
      self.setSidePadding();
    });
  },
  methods: {
    setSidePadding: function () {
      // spacing
      if (window.innerWidth >= 960) {
        this.paddingLeft = 0;
        this.paddingRight = 0;
      } else {
        this.paddingLeft = 16;
        this.paddingRight = 16;
      }
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = (swiper) => {};

    return {
      onSwiper,
      onSlideChange,
      scrollbar: {
        el: "#alumni-spotlights.card-carousel__legend",
        draggable: true,
        dragClass: "card-carousel__legend-bar",
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".alumni-spotlights__swiper-next",
        prevEl: ".alumni-spotlights__swiper-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 1.4,
        },
        960: {
          slidesPerView: 2,
        },
      },
      modules: [Navigation, Scrollbar, Mousewheel],
    };
  },
};
</script>
